import { ref, watch, inject, onMounted, nextTick } from 'vue'
import type { Ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { useValidation } from './useValidation'

interface FormFieldProps {
  field: any
  modelValue?: any
}

interface VueFormContext {
  formState: {
    value: {
      errorLength: number
    }
  }
  validateField: (isValid: boolean) => void
}

export function useFormField(props: FormFieldProps) {
  const selectedValue: Ref<any> = ref(props.modelValue ?? '')
  const { rules } = useValidation(props.field)
  const v$ = useVuelidate(rules, { value: selectedValue })

  const vueform = inject('vueform') as VueFormContext
  if (!vueform) {
    throw new Error('vueform is not provided')
  }
  const { formState, validateField } = vueform

  // Force validation on mount
  onMounted(() => {
    nextTick(() => {
      v$.value.$touch()
      updateFormState()
    })
  })

  watch(selectedValue, () => {
    nextTick(() => {
      v$.value.$touch()
      updateFormState()
    })
  })

  function updateFormState() {
    formState.value.errorLength = v$.value.$silentErrors.length
    validateField(formState.value.errorLength === 0)
  }

  const vFocus = {
    mounted: (el: HTMLElement) => el.focus()
  }

  return {
    selectedValue,
    v$,
    vFocus
  }
}
